import getAgent, { AgentInfo } from '@egjs/agent';
import '@egjs/flicking-plugins/dist/flicking-plugins.css';
import '@egjs/react-flicking/dist/flicking-inline.css';
import '@egjs/react-flicking/dist/flicking.css';
import setupLocatorUI from '@locator/runtime';
import '@techminds/ui/dist/index.css';
import '@travel-ui/mobile-footer/mo-footer.css';
import '@travel-ui/mobile-header/mobile-header.css';
import '@travel-ui/pc-footer/pc-footer.css';
import '@travel-ui/pc-header/pc-header.css';
import App, { AppContext, AppProps } from 'next/app';
import 'rc-slider/assets/index.css';
import { Fragment, useEffect } from 'react';

import { Device } from '@flight-workspace/common-client/src/hooks/useDevice';
import { getSpluginVersion } from '@flight-workspace/common-client/src/util/splugin';
import { withApollo } from 'config/apollo';
import 'config/polyfills';
import { DeviceContext, DeviceType } from 'contexts/device';
import useNlogPageView from 'hooks/useNlogPageView';
import 'list/List.scss';
import config from '../config';
import './index.scss';

if (process.env.NODE_ENV === 'development') {
  setupLocatorUI();
}

interface AppOwnProps {
  agent: AgentInfo;
}

const eventNscMap = new Map([
  [Device.MOBILE, 'Mflight.all'],
  [Device.PC, 'flight.all'],
]);

function MyApp({ Component, pageProps, agent }: AppProps & AppOwnProps) {
  const { isMobile } = agent;

  useEffect(() => {
    window.ntm.push({
      nsc: eventNscMap.get(isMobile ? Device.MOBILE : Device.PC),
    });
  }, [isMobile]);

  useNlogPageView(isMobile);

  return (
    <Fragment>
      {/* eslint-disable-next-line react/jsx-props-no-spreading */}
      <DeviceContext.Provider
        value={isMobile ? DeviceType.MOBILE : DeviceType.PC}
      >
        <Component {...pageProps} />
      </DeviceContext.Provider>
      <script src={`${config.flight}/__ENV.js`} />
      <script
        src={`${config.cdnDomain}/flight/vertical-static/libs/nclk_v0.4.7.js`}
      />
      <script
        src={`${
          isMobile ? config.splugin.mobile : config.splugin.pc
        }?v=${getSpluginVersion()}`}
      />
      <script src={`${config.ntm}`} />
      <script src="https://oapi.map.naver.com/openapi/maps3.js" />
      <script async src={`${config.ad.nam.scriptUrl}`} />
      <script
        dangerouslySetInnerHTML={{
          __html: 'window.gladsdk = window.gladsdk || {cmd: [] };',
        }}
      />
    </Fragment>
  );
}

MyApp.getInitialProps = async (context: AppContext) => {
  const ctx = await App.getInitialProps(context);
  const agent = getAgent(context.ctx.req?.headers['user-agent']);
  return { ...ctx, agent };
};

export default withApollo(MyApp);
